const GOAL_PACE_VALUES = [0.25, 0.5, 0.75, 1]

export default (getView) =>
  ({ nextStepPath, formFields }) => ({
    ...getView({
      nextStepPath,
      formFields,
    }),

    isGeneratingPlan: true,

    init() {
      this.handleLoadingEnd = this.handleLoadingEnd.bind(this)
      this.commonInit()

      if (this.formValues.email) {
        this.isGeneratingPlan = false
      }

      this.store.values.marketingAgreed = false
    },

    handleSubmit() {
      this.store.values.marketingAgreed = true
      this.submit({ push: true })
    },

    handleLoadingEnd() {
      setTimeout(() => {
        this.isGeneratingPlan = false
      }, 2000)
    },
  })
